import { render, staticRenderFns } from "./ChevronDoubleRightIcon.vue?vue&type=template&id=6ce7fe50&scoped=true&"
import script from "./ChevronDoubleRightIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ChevronDoubleRightIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce7fe50",
  null
  
)

export default component.exports